<template>
    <div class="home-view">
        <Topbar />
        <br>
        <div class="container-img mt-2">
            <div class="col-md-6 m-auto">
                <br>
                <div class="card" v-if="this.pedido">
                    <div class="card-header bg-info text-white p-0 small">
                        <div class="row">
                            <div class="col-1">
                                <em class="fa fa-arrow-circle-left ml-2" @click="pesquisar()"></em>
                            </div>
                            <div class="col-10">
                                Pedido Nº {{ pedido.pedido }}
                                <div v-show="carregando" class="spinner-grow">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body p-2 small text-left">
                        <span class="font-weight-bold">
                            Cliente
                        </span>
                        <span class="border pl-1 pr-1 pt-0 pb-0 bg-warning rounded ml-2">
                            {{ pedido.fantasia }} - {{ pedido.idclientes }}
                        </span>
                        <br>
                        <span class="font-weight-bold">
                            Dest.
                        </span>
                        <br>
                        <span class="border pl-1 pr-1 pt-0 pb-0 bg-warning rounded">
                            {{ pedido.nomedest.toUpperCase() }}
                        </span>
                        <br>
                        <span class="font-weight-bold">
                            Transp.
                        </span>
                        <span class="border pl-1 pr-1 pt-0 pb-0 bg-warning rounded ml-2">
                            {{ pedido.transportadora.toUpperCase() }}
                        </span>
                        <br>
                        <span class="font-weight-bold">
                            Status
                        </span>
                        <span class="border pl-1 pr-1 pt-0 pb-0 bg-warning rounded ml-2">
                            {{ pedido.statuslib }}
                        </span>
                        <br>
                    </div>
                </div>

                <div class="card mt-1" v-if="this.pedido">
                    <div class="card-header p-0 small bg-success text-white">
                        Alterar Status do Pedido
                    </div>
                    <div class="card-body p-2 bg-light">
                        <div class="row">
                            <div class="col-6">
                                <button class="btn btn-info w-100" @click="dialogoAcao('AGUARDANDO PACKING')">
                                    AGUARDANDO PACKING
                                </button>
                            </div>
                            <div class="col-6">
                                <button class="btn btn-success w-100" @click="dialogoAcao('AGUARDANDO EXPEDICAO')">
                                    AGUARDANDO EXPEDIÇÃO
                                </button>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-6">
                                <button class="btn btn-danger w-100" @click="dialogoAcao('CANCELADO')">
                                    CANCELADO
                                </button>
                            </div>
                            <div class="col-6">
                                <button class="btn btn-warning w-100 text-white" @click="dialogoAcao('CANCELAMENTO SOLICITADO')">
                                    CANCELAMENTO SOLICITADO
                                </button>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-6">
                                <button class="btn btn-primary w-100" @click="dialogoAcao('AGUARDANDO NOTA FISCAL')">
                                    AGUARDANDO NOTA FISCAL
                                </button>
                            </div>
                            <div class="col-6">
                                <button class="btn btn-secondary w-100 text-white" @click="dialogoAcao('AGUARDANDO ETIQUETA')">
                                    AGUARDANDO ETIQUETA
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Modal
            id="modal1"
            title="Confirme:"
            :carregando="carregando"
            :cancelFunction="() => closeModal('modal1')"
            :confirmFunction="() => alterarStatus()"
        >
            <div class="small text-left">
                <div v-if="this.pedido">
                    Deseja alterar o status do pedido Nº {{ pedido.pedido }}
                    de 
                    <span class="text-primary font-weight-bold">
                        "{{ pedido.statuslib }}"
                    </span>
                    <br>
                    para
                    <br>
                    <span class="text-primary font-weight-bold">
                        "{{ this.statusReferencia }}"
                    </span>?
                    <br>
                    <br>
                    <label for="motivo">Motivo (*)</label>
                    <input type="text" id="motivo" autocomplete="off" class="form-control form-control-sm">
                </div>
            </div>
        </Modal>

        <Modal
            id="modalRetorno"
            title="Sucesso"
            :carregando="carregando"
            :buttonList="[]"
            :cancelFunction="() => closeModal('modalRetorno')"
            cancelText="OK"
        >
            <div class="small text-center">
                <em class="fa fa-check-circle text-success fa-3x"></em>
                <br>
                <br>
                <span>{{ this.retornoMessage }}</span>
            </div>
        </Modal>

        <Modal
            id="modalError"
            title="Erro"
            :carregando="carregando"
            :buttonList="[]"
            :cancelFunction="() => closeModal('modalError')"
            cancelText="OK"
        >
            <div class="small text-center">
                <em class="fa fa-info-circle text-danger fa-3x"></em>
                <br>
                <br>
                <span>{{ this.errorMessage }}</span>
            </div>
        </Modal>

        <LogoutModal />
        <FooterBar />
    </div>
</template>

<script>
    import Topbar from '@/components/Topbar.vue'
    import FooterBar from '@/components/FooterBar.vue'
    import LogoutModal from '@/components/LogoutModal.vue'
    import ViewMixin from './ViewMixin'
    import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
    import api, { getUsername, getPerfil, getUserId } from '../services/api'
    import $ from "jquery"
    import audioService from '@/services/audioService.js';
    import Modal from "../components/Modal.vue"

    export default {
        name: 'EditarPedido',
        mixins: [
            ViewMixin
        ],
        components: {
            Topbar,
            LogoutModal,
            FooterBar,
            Modal,
        },
    
        data: () => {
            return {
                pedido: null,
                statusReferencia: null,
                retornoMessage: null,
                errorMessage: null,
            };
        },
    
        async mounted() {
            try {
                await this.validarToken();
                this.getPedido();
            } catch (e) {
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }      
            }
        },
    
        methods: {
            getUsername,
            getPerfil,

            closeModal(modal) {
                $("#" + modal).modal("hide");
            },

            showMessageSuccess(message) {
                this.retornoMessage = message;
                $("#modalRetorno").modal('show');
            },

            showMessageError(message) {
                this.errorMessage = message;
                $("#modalError").modal('show');
            },

            playSoundSuccess() {
                audioService.success();
            },

            playSoundAlert() {
                audioService.ops();
            },

            getPedido() {
                let b64 = this.$route.query.p
                this.pedido = JSON.parse(atob(b64));
            },


            async validarToken() {
                this.carregando = true;
        
                await api.get("/validar-token");
        
                this.carregando = false;
            },

            pesquisar() {
                this.$router.push("/modificar");
            },

            dialogoAcao(status) {
                this.statusReferencia = status;
                $("#modal1").modal("show");

                setTimeout(() => {
                    $("#motivo").focus();
                }, 500);
            },

            async alterarStatus() {
                let motivo = $("#motivo").val();

                if (motivo.trim() === "") {
                    this.dialogoAcao(this.statusReferencia);
                    $("#motivo").css("border", "1px solid red");
                    $("#motivo").focus();
                    this.playSoundAlert();
                    return;
                }

                $("#motivo").css("border", "1px solid #CCC");
                $("#modal1").modal("hide");
                $("#motivo").val("");

                try {
                    let response = await api.post("/pesquisa/alterarstatus", {
                        "idDocumento": this.pedido.iddocumentos,
                        "idUsuario": getUserId(),
                        "novoStatus": this.statusReferencia,
                        "statusAtual": this.pedido.statuslib,
                        "motivo": motivo
                    });

                    if (JSON.stringify(response).includes("idDocumento")) {
                        this.showMessageSuccess(`
                            Pedido Nº ${this.pedido.pedido} alterado para
                            "${this.statusReferencia}" com sucesso!
                        `);
                        this.playSoundSuccess();

                        this.pedido.statuslib = this.statusReferencia;
                    }
                } catch (error) {
                    this.showMessageError(error.message);
                    this.playSoundAlert();
                }
            }
        }
    }
</script>

<style scoped lang="scss">    
  
    .home-view {
        height: 100%;
    }
  
    .container-img {
        height: auto;
        display: flex;
        justify-content: center;
        align-self: center;
    }

    .btn {
        font-size: 10px;
        height: 60px;
    }
</style>
